<template>
  <div>
    <div class="top-panel">
      <div class="filter">
        <div style="padding: 5px 0;">
          <div>Rank:</div>
          <Multiselect  style="width: 245px; margin: 0"
            v-model="this.filterRanks"
            :options="this.ranks"
            :searchable="true"
            :multiple="true"
            mode="tags"
          />
        </div>
        <div style="padding: 5px 0;">
          <div>Sizes:</div>
          <Multiselect
            v-model="this.filterSizes"
            :options="this.sizes"
            :searchable="true"
            :multiple="true"
            mode="tags"
            label="name"
            valueProp="id"
          />
        </div>
      </div>
    
      <div v-if="owners.length != 0" style="padding: 5px 10px; align-content: flex-end;">
        <!-- <div style="font-size: 1.25em;">Email Template</div>
        <textarea name="" id="" rows="10"></textarea>
        <select name="" id="">
          <option value="Fid1">Fid1</option>
          <option value="Fid2" selected>Fid2</option>
          <option value="Fid3">Fid3</option>
        </select> -->
        <!-- <div
          class="template-button"
          @click="() => {
            this.showModalEmailTemplatePopUp = true;
          }"
        >
          <span>Email Template</span>
        </div> -->
      </div>
    </div>
    <div class="report-body-wrap" v-if="owners.length != 0">
      <div class="report-body">
        <table class="report-table">
          <thead>
            <tr class="report-table__head">
              <th>Owner</th>
              <!-- <th>Quoted</th> -->
              <template v-for="index in quoteColumns" :key="index">
                <th style="display: flex; align-items: center;" v-if="index == quoteColumns && quoteColumns < 5">
                  <div>
                    <div>{{ this.getQuoteColumnDate(index) }}</div>
                    <div>Quoted</div>
                  </div>
                  <div v-if="!this.savingQuoteColumn" 
                    v-on:click="() => {
                      this.addQuoteColumn(index);
                    }"
                    style="padding: 10px; background: #2d3757;
                    border-radius: 2px;
                    color: #ffffff;
                    margin-left: 10px;
                    font-size: 1.2em;
                    cursor: pointer;">
                    +
                  </div>
                  <div v-else>
                    <CustomLoader />
                  </div>
                </th>
                <th v-else>
                  <div>{{ this.getQuoteColumnDate(index) }}</div>
                  <div>Quoted</div>
                </th>
              </template>
              <th>Offer</th>
              <th>Notes</th>
              <th>Date Updated</th>
              <th>Contacts</th>
              <th>Concatenated Email</th>
              <!-- <th>
                <div style="padding: 10px;">
                  <div style="font-size: 1.25em;">Email Template</div>
                  <textarea name="" id="" rows="10"></textarea>
                  <select name="" id="">
                    <option value="Fid1">Fid1</option>
                    <option value="Fid2" selected>Fid2</option>
                    <option value="Fid3">Fid3</option>
                  </select>
                </div>
              </th> -->

              <th>
                <div>Emails Sent</div>
              </th>
              <th>
                Emails Received
              </th>

              <th>
                <div
                  class="template-button"
                  @click="() => {
                    this.showModalEmailTemplatePopUp = true;
                  }"
                >
                  <!-- <div class="close-button__img"></div> -->
                  <span>Email Template</span>
                </div>
                <div>Email Body</div>
              </th>
              <th style="min-width: 60px;">
                <div
                    class="reply-all-button"
                    @click="() => {
                      this.sendAllEmail();
                    }"
                >
                  <span>Reply All</span>
                </div>
                <div>Reply</div>
              </th>
              <!-- <th>Send</th> -->
              <!-- <th v-for="item in fields" :key="item.id">
              <div>{{ item.label }}</div>
            </th> -->
            </tr>
          </thead>
          <tbody>
            <template v-for="(owner, index) in prepOwners" :key="index">
              <tr>
                <td>{{ owner.name }}</td>
                <template v-if="this.getBestOffer(owner) !== null">
                  
                  <!-- <td>
                    <div style="text-align: center">
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        
                        v-model="this.getBestOffer(owner).approved"
                      />
                    </div>
                  </td> -->
                  <template v-for="indexQuote in quoteColumns" :key="indexQuote">
                    <td class="checkbox-cell">
                      <div style="text-align: center">
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :checked="getApprovedValue(owner, indexQuote)"
                          @change="updateApprovedCkeckboxValue($event, owner, indexQuote)"
                        />
                      </div>
                      <div style="text-align: center;">
                        {{ priceFormatOffer(getQuotedPrice(owner, indexQuote)) }}
                      </div>
                    </td>
                  </template>
                  <td>
                    <div style="display: flex; justify-content: flex-start; align-items: center;">
                      <template  v-if="this.getQuotedFid(owner) == 27">
                        <div>
                          <!-- <div style="font-size: 12px;">Offer 1</div> -->
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 27).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 37">
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 37).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 38">
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 38).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 39">
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 39).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 40">
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 40).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 'new'">
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 40).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>

                      <template v-else>
                        <div>
                          <div>
                            <CurrencyInput
                              v-model="getQuotedOfferByFid(owner, 27).offer"
                              :options="{ currency: 'USD', precision: 2 }"
                              class="q-currency-input"
                            />
                          </div>
                        </div>
                      </template>
                  
                      <div v-if="this.prepOffersLog(owner.offers).length >= 2" class="btn-log field-title__btn-log" @click="(e) => {}">
                        <span>!</span>
                        <div class="btn-log__body">
                          <div>
                            <div :key="index" v-for="(value, index) in this.prepOffersLog(owner.offers)">
                              <div>{{ value }}</div>
                              <div>---------------------------</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="btn-log field-title__btn-log" @click="(e) => {}">
                        <span>!</span>
                        <div class="btn-log__body">
                          <div v-if="this.prepOffersLog(owner.offers) != 0">
                            <div :key="index" v-for="(value, index) in this.prepOffersLog(owner.offers)">
                              <div>{{ value }}</div>
                              <div>---------------------------</div>
                            </div>
                          </div>
                          <div v-else>(empty)</div>
                        </div>
                      </div> -->

                    </div>
                  </td>
                  <!-- <td>{{ this.getBestOffer(owner).notes }}</td> -->
                  <td>
                    <textarea class="" v-model="this.getBestOffer(owner).notes" name="" id="" cols="30" rows="2"></textarea>
                  </td>
                  
                  <td>
                      <template  v-if="this.getQuotedFid(owner) == 27">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 27).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 37">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 37).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 38">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 38).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 39">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 39).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 40">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 40).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else-if="this.getQuotedFid(owner) == 'new'">
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 40).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>

                      <template v-else>
                        <DatePicker
                          :format="(t) => formatDateTimeFunc(t)"
                          :previewFormat="
                            (t) => formatDateTimeFunc(t)
                          "
                          v-model="getQuotedOfferByFid(owner, 27).date_updated"
                          :hideInputIcon="true"
                          inputClassName="dp-custom-input"
                        />
                      </template>
                  
                    <!-- <DatePicker v-else
                      :format="(t) => formatDateTimeFunc(t)"
                      :previewFormat="
                        (t) => formatDateTimeFunc(t)
                      "
                      v-model="this.getBestOffer(owner).date_updated"
                      :hideInputIcon="true"
                      inputClassName="dp-custom-input"
                    /> -->
                  </td>
                  <!-- <td>{{ this.getBestOffer(owner).date_updated }}</td> -->
                  <td>
                    <div class="contact-cell-wrapper">
                      <div class="contact-names">
                        <template v-for="(value, i) in this.individualsName(owner)" :key="i">
                          <div>
                            {{ value }}
                          </div>
                        </template>
                        <template v-for="(value, i) in owner.contacts" :key="i">
                          <div>
                            {{ value.first_name }} {{ value.surname }}
                          </div>
                        </template>
                      </div>
                      <button 
                        class="contact-edit-button"
                        @click="openContactEditModal(owner)"
                        title="Edit Contact"
                      >
                        <div class="edit-icon"></div>
                      </button>
                    </div>
                  </td>
                  <td @click="() => {
                    this.copyText(this.individualsEmails(owner));
                  }" style="cursor: pointer;">
                    <template v-for="(value, i) in this.individualsEmails(owner)" :key="i">
                      <div>
                        {{ value }}
                      </div>
                    </template>
                    <template v-for="(value, i) in owner.contacts" :key="i">
                      <div>
                        {{ value.email }}
                      </div>
                    </template>
                  </td>

                  <!-- <td>
                    <div style="cursor: pointer; display: flex; flex-wrap: wrap; gap: 4px;">
                      <EmailField label="To" v-model="this.getBestOffer(owner).emails" />
                    </div>
                  </td> -->

                  <td>
                    <div style="display: flex; justify-content: center"
                      @click="() => {
                      }"
                    >
                      <div class="">{{ this.getBestOffer(owner).emails_sent_count }}</div>
                    </div>
                  </td>
                  <td>
                    <div style="display: flex; justify-content: center; cursor: pointer; color: #2d3757; text-decoration: underline;"
                      @click="() => {
                        openEmailReceivedPopup(this.getBestOffer(owner).received_emails);
                      }"
                    >
                      <div class="">{{ this.getBestOffer(owner).received_emails.length }}</div>
                    </div>
                  </td>

                  <td>
                    <div style="display: flex; justify-content: center"
                      @click="() => {
                        // this.showModalEmailOwnerTemplatePopUp = true;
                        openOwnerTemplatePopup(this.getBestOffer(owner).id);
                      }"
                    >
                      <div class="preview-button__img"></div>
                    </div>
                  </td>

                  <td>
                    <div style="display: flex; justify-content: center"
                      @click="() => {
                        // this.showModalEmailOwnerTemplatePopUp = true;
                        this.sendOwnerEmail(owner.id);
                      }"
                    >
                      <div class="send-button__img"></div>
                    </div>
                  </td>

                  <!-- <td></td> -->
                  
                  <!--<td class="send-done-wrap">
                    <div class="imgs-wrap">
                      <img src="../../assets/send-icon.svg" alt="send-icon" class="send-icon">
                      <img src="../../assets/check-done-icon.svg" alt="check-done-icon" class="check-done-icon">
                    </div>
                  </td>-->
                </template>
                <template v-else>
                  <!--<td>
                    <div style="text-align: center">
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        true-value="true"
                        false-value="false"
                        @change="addNewOffer($event, owner.id)"
                      />
                    </div>  
                  </td> -->

                  <template v-for="indexQuote in quoteColumns" :key="indexQuote">
                    <td>
                      <template v-if="indexQuote == 1">
                        <div style="text-align: center">
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            true-value="true"
                            false-value="false"
                            :checked="getApprovedValue(owner, indexQuote)"
                            @change="updateApprovedCkeckboxValue($event, owner, indexQuote, true)"
                          />
                        </div>
                      </template>
                      <template v-else>
                        <div style="text-align: center">
                          <input
                            type="checkbox"
                            name=""
                            id=""
                            disabled
                          />
                        </div>
                      </template>
                    </td>
                  </template>
                  
                  <template v-if="showNewFields(owner.id)">
                    <td>
                      <CurrencyInput
                        v-model="this.newOffers[owner.id].quotes[0].offer"
                        :options="{ currency: 'USD', precision: 2 }"
                      />
                    </td>
                    <td>
                      <textarea class="" v-model="this.newOffers[owner.id].notes" name="" id="" cols="30" rows="2"></textarea>
                    </td>
                    <td>
                      <DatePicker
                        :format="(t) => formatDateTimeFunc(t)"
                        :previewFormat="
                          (t) => formatDateTimeFunc(t)
                        "
                        v-model="this.newOffers[owner.id].date_updated"
                        :hideInputIcon="true"
                        inputClassName="dp-custom-input"
                      />
                      <!-- v-model="value.value"
                        :disabled="true" -->
                    </td>
                    
                  </template>
                  <template v-else>
                    <td>
                      <div class="field__empty">
                        <span>
                          -
                        </span>
                      </div>
                    </td>
                    <td>-</td>
                    <td>-</td>
                  </template>
                  <td>
                    <div class="contact-cell-wrapper">
                      <div class="contact-names">
                        <template v-for="(value, i) in this.individualsName(owner)" :key="i">
                          <div>
                            {{ value }}
                          </div>
                        </template>
                        <template v-for="(value, i) in owner.contacts" :key="i">
                          <div>
                            {{ value.first_name }} {{ value.surname }}
                          </div>
                        </template>
                      </div>
                      <button 
                        class="contact-edit-button"
                        @click="openContactEditModal(owner)"
                        title="Edit Contact"
                      >
                        <div class="edit-icon"></div>
                      </button>
                    </div>
                  </td>
                  <td @click="() => {
                    this.copyText(this.individualsEmails(owner));
                  }" style="cursor: pointer;">
                    <template v-for="(value, i) in this.individualsEmails(owner)" :key="i">
                      <div>
                        {{ value }}
                      </div>
                    </template>
                    <template v-for="(value, i) in owner.contacts" :key="i">
                      <div>
                        {{ value.email }}
                      </div>
                    </template>
                    <!-- {{ this.individualsEmails(owner) }} -->
                  </td>

                  <td
                  >
                  <!-- {{ this.individualsEmails(owner) }} -->
                  <div style="cursor: pointer; display: flex; flex-wrap: wrap; gap: 4px;">
                    <!-- <template
                      v-for="(email, index) in flattenedEmails(individualsEmails(owner))"
                      :key="index"
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          background-color: #e0e0e0;
                          border-radius: 16px;
                          padding: 4px 8px;
                          font-size: 13px;
                        "
                      >
                        {{ email }}
                        <button
                          style="
                            margin-left: 8px;
                            background: transparent;
                            border: none;
                            cursor: pointer;
                            font-weight: bold;
                          "
                          @click.stop
                        >
                          ✕
                        </button>
                      </div>
                    </template> -->
                  </div>
                  </td>
                  <td>
                    <!-- <div
                      class="template-button"
                      @click="() => {
                        this.showModalEmailOwnerTemplatePopUp = true;
                      }"
                    >
                      <span>Edit Template</span>
                    </div> -->
                  </td>
                  <td></td>
                  <td></td>
                  <!-- <td></td> -->
                  <!--<td class="send-done-wrap">
                    <div class="imgs-wrap">
                      <img src="../../assets/send-icon.svg" alt="send-icon" class="send-icon">
                      <img src="../../assets/check-done-icon.svg" alt="check-done-icon" class="check-done-icon">
                    </div>
                  </td>-->
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <EmailTemplatePopUp 
      v-if="showModalEmailTemplatePopUp"
      :open="showModalEmailTemplatePopUp"
      :recordKey="keyForTasks"
      @showStatus="showEditEmailTemplatePopUp"
      :templateText="this.cargo.email_template"
      :subjectText="this.cargo.email_subject_template"
      @saveEmailTemplate="saveEmailTemplate"
      :cargoId="this.cargo.id"
    />

    <EmailReceivedPopUp 
      v-if="showModalEmailReceivedPopUp"
      @showStatus="showEmailReceivedPopUp"
      :emails="receivedEmails.sort((a, b) => new Date(JSON.parse(b.email)['Date']) - new Date(JSON.parse(a.email)['Date']))"
    />

    <!-- <EmailOwnerTemplatePopUp 
      v-if="showModalEmailOwnerTemplatePopUp"
      :open="showModalEmailOwnerTemplatePopUp"
      :recordKey="keyForTasks"
      :offerId="currentOfferIdForEmailTemplate"
      @showStatus="showEditEmailOwnerTemplatePopUp"
      :templateText="this.cargo.email_template"
      @saveEmailTemplate="saveEmailTemplate"
    /> -->

    <EmailOwnerPreviewPopUp 
      v-if="showModalEmailOwnerTemplatePopUp"
      :open="showModalEmailOwnerTemplatePopUp"
      :recordKey="keyForTasks"
      :offerId="currentOfferIdForEmailTemplate"
      @showStatus="showEditEmailOwnerTemplatePopUp"
      :templateText="this.cargo.email_template"
      :templateSubjectText="this.cargo.email_subject_template"
      @saveEmailTemplate="saveEmailTemplate"
    />

    <EditContactPopUp
      v-if="showContactEditModal"
      :open="showContactEditModal"
      :cargo-id="this.cargo?.id"
      :owner-id="currentOwnerForContactEdit?.id"
      :owner-name="currentOwnerForContactEdit?.name || currentOwnerForContactEdit?.owner_name || 'Unknown Owner'"
      :filter-ranks="this.filterRanks"
      :filter-sizes="this.filterSizes"
      :zone-id="this.zoneId"
      :sizes="this.sizes"
      @showStatus="handleContactModalStatus"
      @contactUpdated="handleContactUpdated"
    />
  </div>
</template>

<script>
import moment from "moment";

import Multiselect from "@vueform/multiselect";
import Cargo from "@/api/tradingPlatform/cargo";
import Size from "@/api/tradingPlatform/size";
import Voyage from "@/api/tradingPlatform/voyage";
import Offer from "@/api/tradingPlatform/offer";
import CurrencyInput from "@/components/CurrencyInput.vue";

import CustomLoader from "@/components/loader/CustomLoader.vue";

import EmailTemplatePopUp from "./components/EmailTemplatePopUp";
import EmailOwnerPreviewPopUp from "./components/EmailOwnerPreviewPopUp";
import EmailReceivedPopUp from "./components/EmailReceivedPopUp.vue";
import EditContactPopUp from "@/components/pop-up/EditContactPopUp.vue";



export default {
  name: "OwnersForCargoField",
  components: {
    Multiselect,
    CurrencyInput,
    CustomLoader,
    EmailTemplatePopUp,
    EmailOwnerPreviewPopUp,
    EmailReceivedPopUp,
    EditContactPopUp,
  },
  props: {
    rid: Number,
  },
  data: function () {
    return {
      clst: [],
      owners: [],
      cargo: {},
      zoneId: null,
      zone: "",
      filterBase: {},
      sizes: [],
      // windowTop: Number,
      filterSizes: [],
      prepOwners: [],
      ranks: [0, 1, 2, 3],
      filterRanks: [0, 1, 2, 3],
      newOffers: {},
      quoteColumns: 1,
      addedNewQuoteColumn: false,
      savingQuoteColumn: false,
      newOfferQuotes: {},
      // quotesOrder: [27, 37, 38, 39, 40],
      quotesOrder: [
        {
          date: 11,
          quoted: 27,
          displayDate: moment(new Date()).format("MMM DD"),
        },
        {
          date: 41,
          quoted: 37,
          displayDate: moment(new Date()).format("MMM DD"),
        },
        {
          date: 42,
          quoted: 38,
          displayDate: moment(new Date()).format("MMM DD"),
        },
        {
          date: 43,
          quoted: 39,
          displayDate: moment(new Date()).format("MMM DD"),
        },
        {
          date: 44,
          quoted: 40,
          displayDate: moment(new Date()).format("MMM DD"),
        },
      ],

      showModalEmailTemplatePopUp: false,
      showModalEmailOwnerTemplatePopUp: false,
      currentOfferIdForEmailTemplate: null,

      selectedVariable: null,
      availableVariables: [
        
      ],

      receivedEmails: [],
      showModalEmailReceivedPopUp: false,
      
      // Contact editing data
      showContactEditModal: false,
      currentOwnerForContactEdit: null,
      contactData: {
        contact: {},
        contactedEmail: ""
      },
    };
  },
  async mounted() {
    this.getData();
    this.getSizesForFilter();
    this.getDefaultSizesForFilter();
    // window.addEventListener("scroll", this.onScroll, true);
  },
  // beforeUnmount() {
  //   window.removeEventListener("scroll", this.onScroll, true)
  // },
  watch: {
    filterSizes() {
      this.filterApply();
    },
    filterRanks() {
      this.filterApply();
    },
  },
  computed: {
    quotes(owner) {
      return this.getBestOffer(owner).quotes;
    },
  },

  methods: {
    // scrollToMultiselect() {
    //   window.console.log(this.windowTop)
    //   if(this.windowTop >= 675 && this.windowTop <= 755) {
    //     window.scrollTo({left:0, top: 755});
    //   }
    // },
    // onScroll(e) {
    //   this.windowTop = e.target.scrollTop;
    // },
    sendAllEmail() {
      Cargo.sendEmailToOwners(this.cargo.id).then((response) => {
        console.log(response);
        this.emitter.emit("messageNotificationSent", "Email sent!");
      });
    },

    sendOwnerEmail(ownerId) {
      Cargo.sendEmailToOwner(this.cargo.id, ownerId).then(() => {
        this.emitter.emit("messageNotificationSent", "Email sent!");
      });
    },

    openOwnerTemplatePopup(offerId) {
      this.currentOfferIdForEmailTemplate = offerId;
      this.showModalEmailOwnerTemplatePopUp = true;
    },

    openEmailReceivedPopup(receivedEmails) {
      this.showModalEmailReceivedPopUp = true;
      console.log("openEmailReceivedPopup: " + receivedEmails);

      if (receivedEmails.length > 0) {
        // this.emitter.emit("openEmailReceivedPopUp", receivedEmails);
        this.receivedEmails = receivedEmails;
        this.showModalEmailReceivedPopUp = true;
      } else {
        this.emitter.emit("messageNotificationSent", "No emails received");
      }
    },

    flattenedEmails(emailStringsArray) {
      return emailStringsArray
        .flatMap(str => str.split(/[,;]+/)) // розбиває по , або ;
        .map(email => email.trim())
        .filter(email => email.length > 0);
    },
    prepOffersLog(offers) {
      let res = [];
      let resArray = [];
      for (const key in offers) {
        const offer = offers[key];
        for(const offerLogKey in offer["offer_logs"]) {

          const offerLog = offer["offer_logs"][offerLogKey];
          // res.push(this.currencyFormat(offerLog.offer) + " : " + this.formatDateTimeForLog(offerLog.date_updated));
          resArray.push({
            offer: offerLog.offer,
            date_updated: offerLog.date_updated,
          });
        }

        for(const offerQuoteKey in offer["quotes"]) {
          const offerQuote = offer["quotes"][offerQuoteKey];
          for (const offerQuoteLogKey in offerQuote["logs"]) {
            const offerQuoteLog = offerQuote["logs"][offerQuoteLogKey];
            // res.push(this.currencyFormat(offerQuoteLog.offer) + " : " + this.formatDateTimeForLog(offerQuoteLog.date_updated));
            resArray.push({
              offer: offerQuoteLog.offer,
              date_updated: offerQuoteLog.date_updated,
            });
          }
        }

        /* if(offer.offer != null && offer.date_updated != null) {
          // res.push(this.currencyFormat(offer.offer) + " : " + this.formatDateTimeForLog(offer.date_updated));
        } */
      }
      

      resArray.sort((a, b) => {
          var dateA = new Date(a.date_updated);
          var dateB = new Date(b.date_updated);
          return dateA - dateB;
      });

      resArray.forEach((item) => {
        res.push(this.currencyFormat(item.offer) + " : " + this.formatDateTimeForLog(item.date_updated));
        // res.push(this.currencyFormat(item.offer) + " : " + item.date_updated);
      });
      return res;
    },

    showEditEmailTemplatePopUp(status) {
      this.showModalEmailTemplatePopUp = status;
      console.log("showEditEmailTemplatePopUp: " + status);
    },

    showEmailReceivedPopUp(status) {
      this.showModalEmailReceivedPopUp = status;
      console.log("showEmailReceivedPopUp: " + status);
      if (status == false) {
        this.receivedEmails = [];
      }
    },

    showEditEmailOwnerTemplatePopUp(status) {
      this.showModalEmailOwnerTemplatePopUp = status;
      console.log("showEditEmailOwnerTemplatePopUp: " + status);
    },
    
    copyText(textToCopy) {
        let text = textToCopy.join("; ");
        console.log("test2");
        // Створюємо невидимий textarea для копіювання тексту
        const textarea = document.createElement("textarea");
        textarea.style.position = "fixed";
        textarea.style.top = 0;
        textarea.style.left = 0;
        textarea.style.width = "2em";
        textarea.style.height = "2em";
        textarea.style.padding = 0;
        textarea.style.border = "none";
        textarea.style.outline = "none";
        textarea.style.boxShadow = "none";
        textarea.style.background = "transparent";
        textarea.value = text;
        document.body.appendChild(textarea);

        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.emitter.emit("messageNotificationSent", "Copied!");
        // this.isCopied = true;
        // setTimeout(() => {
        //   this.isCopied = false;
        // }, 2000);
    },
    addNewOffer(e, ownerId) {
      console.log(e.target.checked);
      console.log(ownerId in this.newOffers);
      if(e.target.checked == true && !(ownerId in this.newOffers)) {
        console.log("add");
        this.newOffers[ownerId] = {
          approved: true, 
          cargo_id: this.cargo.id,
          owner_id: ownerId,
          notes: "",
          offer: null,
          quotes: [
            {
              approved: true,
              fid: 27,
              offer: null,
            }
          ],
          // offer: null,
          // date_updated: null,
        };
        // this.newOffers.set(ownerId, { approved: true });
      } else if(e.target.checked == false && (ownerId in this.newOffers)) {
        delete this.newOffers[ownerId];
      }
    },
    showNewFields(ownerId) {
      return (ownerId in this.newOffers);
    },
    formatDateTimeFunc(date) {
      if (date) {
        return (
          moment(date)
            // .tz("US/Pacific")
            .format("MM-DD-yyyy h:mm a")
        ); // America/New_York
      } else {
        return "";
      }
    },

    formatDateTimeForLog(date) {
      if (date) {
        return (
          moment(date).isSame(new Date(), 'year')
          ? moment(date).format("MMM DD")
          : moment(date).format("MMM DD yyyy")
        ); // America/New_York
      } else {
        return "";
      }
    },

    getData() {
      Cargo.getCargoByRid(this.rid).then((response) => {
        this.cargo = response.data["data"];

        // Offer.getOffersByCargoId(this.cargo["id"]);

        if(this.cargo["filter_json"]) {
          this.filterBase = JSON.parse(this.cargo["filter_json"]);
          this.filterSizes = this.filterBase["sizes"];
          this.filterRanks = this.filterBase["ranks"];
        }
        if (this.cargo && this.cargo["voyage"] && this.cargo["voyage"]["load_port"] && this.cargo["voyage"]["load_port"]["zone"]) {
          this.zoneId = this.cargo["voyage"]["load_port"]["zone"]["id"];
          this.zone = this.cargo["voyage"]["load_port"]["zone"]["name"];
        }

        for(const k in this.quotesOrder) {
          for (const key in this.cargo.quotes) {
            console.log("======123===3345534");
            console.log(this.cargo.quotes[key]);
            console.log(this.quotesOrder[k].quoted);
            if(this.cargo.quotes[key]["fid"] == this.quotesOrder[k].quoted) {
              this.quoteColumns = +k+1;
            }
          }
        }
        this.filterApply();
      });
      Cargo.getOwnersByCargoRid(this.rid).then((response) => {
        this.owners = response.data["data"];
        this.prepOwners = response.data["data"];
        this.filterApply();
      });

      
      
      
    },
    getBestOffer(owner) {
      console.log(owner.offers);
      let offer = null;
      if (owner.offers.length != 0) {
        let price = owner.offers[0].offer;
        offer = owner.offers[0];
        for (const key in owner.offers) {
          if (Object.hasOwnProperty.call(owner.offers, key)) {
            const element = owner.offers[key];
            if (element.offer > price) {
              offer = element;
              price = element.offer;
            }
          }
        }
      }

      if(offer) {
        offer.approved = offer.approved ? true : false;

        if(offer.quotes.length > this.quoteColumns) {
          this.quoteColumns = offer.quotes.length;
        }
      }
      
      return offer;
    },

    getQuotedOffer(owner) {
      let offer = this.getBestOffer(owner);
      if(offer) {
        if(!("quotes" in offer)) return false;
        for(let i = this.quotesOrder.length-1; i >= 0; i--) {
          console.log("quotesOrder: " + this.quotesOrder[i].quoted);
          const quote = offer.quotes.find((el) => {
            console.log(el.fid);
            if(!el) return false;
            console.log((el.fid == this.quotesOrder[i].quoted && !!el.approved));
            return el.fid == this.quotesOrder[i].quoted && !!el.approved;
          });
          
          if(quote) {
            return quote
          }
        }
      }
      return offer;
    },

    getEmailsForOffer(owner) {
      let emails = [];
      if(this.getBestOffer(owner)) {
        if("emails" in this.getBestOffer(owner)) {
          emails = JSON.parse(this.getBestOffer(owner).emails);
        }
      }
      return emails;
    },

    getQuotedOfferByFid(owner, fid) {
      let offer = this.getBestOffer(owner);

      // if(this.addedNewQuoteColumn) {
      //   console.log("===!getQuotedOfferByFid");
      //   if(!(offer.id in this.newOfferQuotes)) this.newOfferQuotes[offer.id] = {};
      //   if(!((this.quotesOrder[this.quoteColumns-1].quoted) in this.newOfferQuotes[offer.id])) this.newOfferQuotes[offer.id][this.quotesOrder[this.quoteColumns-1].quoted] = {
      //     offer: null,
      //     date_updated: null,
      //     fid: this.quotesOrder[this.quoteColumns-1].quoted,
      //   }
      //   return this.newOfferQuotes[offer.id][this.quotesOrder[this.quoteColumns-1].quoted];
      // }
      // console.log("===!getQuotedOfferByFid2");

      if(offer) {
        if(!("quotes" in offer)) return false;

        // get last approved quote
        let quote = offer.quotes.find((el) => {
          console.log(el.fid);
          if(!el) return false;
          console.log((el.fid == fid && !!el.approved));
          return el.fid == fid && !!el.approved;
        });
        
        if(quote) {
          return quote
        } else {
          quote = offer.quotes.find((el) => {
            if(!el) return false;
            return el.fid == fid;
          });
          if(quote) {
            return quote
          }
        }
      }
      return offer;
    },

    getQuotedRid(owner) {
      let offer = this.getBestOffer(owner);
      if(offer) {
        if(!("quotes" in offer)) return false;
        for(let i = this.quotesOrder.length-1; i >= 0; i--) {
          const quote = offer.quotes.find((el) => {
            console.log(el.fid);
            if(!el) return false;
            console.log((el.fid == this.quotesOrder[i].quoted && !!el.approved));
            return el.fid == this.quotesOrder[i].quoted && !!el.approved;
          });
          
          if(quote) {
            return quote.rid
          }
        }
      }
      return null;
    },

    getQuotedFid(owner) {
      let offer = this.getBestOffer(owner);
      console.log("getQuotedFid");
      console.log(owner.name);
      // if(this.addedNewQuoteColumn) return "new";
      if(offer) {
        if(!("quotes" in offer)) return false;
        let fid = this.quotesOrder[this.quoteColumns-1].quoted;
        for(let i = this.quotesOrder.length-1; i >= 0; i--) {
          const quote = offer.quotes.find((el) => {
            console.log(el.fid);
            if(!el) return false;
            console.log((el.fid == fid && !!el.approved));
            return el.fid == fid /* && !!el.approved */;
          });
          
          if(quote) {
            console.log(quote);
            console.log(quote.fid);

            return quote.fid
          } else {
            offer.quotes.push({
              approved: 0,
              fid: fid,
              date_updated: null,
              offer: null,
            });
            return fid;
          }
        }
      }
      return null;
    },

    getApprovedValue(owner, index) {
      if(!this.getBestOffer(owner)) return false;
      if(!("quotes" in this.getBestOffer(owner))) return false;
      const quote = this.getBestOffer(owner).quotes.find((el) => {
        if(!el) return false;
        return el.fid == this.quotesOrder[index - 1].quoted;
      });

      return quote ? quote.approved : false;
    },

    getQuotedPrice(owner, index) {
      if(!this.getBestOffer(owner)) return "";
      if(!("quotes" in this.getBestOffer(owner))) return "";
      const quote = this.getBestOffer(owner).quotes.find((el) => {
        if(!el) return false;
        return (el.fid == this.quotesOrder[index - 1].quoted);
      });

      return quote ? quote.offer : "";
    },

    updateApprovedCkeckboxValue(e, owner, index, first = false) {
      if(first) {
        this.addNewOffer(e, owner.id);
      }

      const newIndex = index - 1;
      const quote = this.getBestOffer(owner).quotes.find((el) => {
        if(!el) return false;
        return ("fid" in el) && el.fid == this.quotesOrder[newIndex].quoted;
      });

      if(quote) {
        quote.approved = e.target.checked;
      } else {
        this.getBestOffer(owner).quotes[newIndex] = {
          approved: e.target.checked,
          offer_id: this.getBestOffer(owner).id,
          fid: this.quotesOrder[newIndex].quoted,
        }
      }
    },

    addQuoteColumn(index) {
      console.log(this.quotesOrder[index]);
      this.savingQuoteColumn = true;

      Cargo.addQuoteForCargoByID(this.cargo.id, this.quotesOrder[index].quoted).then((/* response */) => {
        this.savingQuoteColumn = false;
        if(this.quoteColumns < 5) {
          this.quoteColumns++;
          this.addedNewQuoteColumn = true;
        } else {
          alert("maximum: 5 columns")
        }
      }).catch(() => {
        this.savingQuoteColumn = false;
      });

      // if(this.quoteColumns < 5) {
      //   this.quoteColumns++;
      //   this.addedNewQuoteColumn = true;
      // } else {
      //   alert("maximum: 5 columns")
      // }
    },

    getQuoteColumnDate(index) {
      let result = null;
      let minDate = Infinity;

      if(this.cargo.quotes) {
        for (const key in this.cargo.quotes) {
          if(this.cargo.quotes[key]["fid"] == this.quotesOrder[index - 1].quoted) {
            result = this.cargo.quotes[key];
          }
        }
      }

      if(!result) {
        for (const key in this.owners) {
          if (Object.hasOwnProperty.call(this.owners, key)) {
            const owner = this.owners[key];
            for (const key in owner.offers) {
              if (Object.hasOwnProperty.call(owner.offers, key)) {
                const offer = owner.offers[key];

                for(let quoteKey in offer.quotes) {
                  let quote = offer.quotes[quoteKey];
                  if (quote.fid == this.quotesOrder[index - 1].quoted) {
                    var createDate = new Date(quote.date_create);
                    if (createDate < minDate) {
                      minDate = createDate;
                      result = quote;
                    }
                  }
                }
              }
            }
          }
        }
      }

      if(result) {
        return moment(result.date_create).isSame(new Date(), 'year')
          ? moment(result.date_create).format("MMM DD")
          : moment(result.date_create).format("MMM DD yyyy");
      } else {
        /* return moment(new Date()).isSame(new Date(), 'year')
          ? moment(new Date()).format("MMM DD")
          : moment(new Date()).format("MMM DD yyyy"); */
          return moment(this.cargo.date_create).isSame(new Date(), 'year')
          ? moment(this.cargo.date_create).format("MMM DD")
          : moment(this.cargo.date_create).format("MMM DD yyyy");
      }
    },
    
    calculateQuoteColumnDates() {

    },

    async sendToQB() {
      console.log("FGGGGGGGG");
      let offers = [];
      for (const key in this.owners) {
        if (Object.hasOwnProperty.call(this.owners, key)) {
          const owner = this.owners[key];
          for (const key in owner.offers) {
            if (Object.hasOwnProperty.call(owner.offers, key)) {
              const element = owner.offers[key];
              if("date_updated" in element && element["date_updated"]) {
                // element["date_updated"] = moment(element["date_updated"]).toISOString();
                element["date_updated"] = moment(element["date_updated"]).format('YYYY-MM-DDTHH:mm:ss.SSS');
              }

              offers.push(element);
            }
          }
        }
      }
      console.log(offers);

      Offer.addOffers(this.newOffers).then((response) => {
        console.log("response updateOffers");
        console.log(response);
      });

      Offer.updateOffers(offers).then((response) => {
        console.log("response updateOffers");
        console.log(response);
      });

      // Offer.addOfferQuotes(this.newOfferQuotes).then((response) => {
      //   console.log("response addOfferQuotes");
      //   console.log(response);
      // });

      Cargo.updateFilterForOwnerByCargoRid(this.rid, {
        sizes: this.filterSizes.reduce((accumulator, value) => {
          if (!accumulator.includes(value)) {
            accumulator.push(value);
          }
          return accumulator;
        }, []),
        ranks: this.filterRanks.reduce((accumulator, value) => {
          if (!accumulator.includes(value)) {
            accumulator.push(value);
          }
          return accumulator;
        }, []),
      });
    },
    priceFormat(price) {
      return this.currencyFormat(price);
    },
    priceFormatOffer(price) {
      return this.currencyFormat(price);
    },
    currencyFormat(value) {
      // currencyFormat(value) {
      if (value) {
        /* let formatedValue = value.toLocaleString("en-US", {
            style: 'currency',
          }); */
        let formatter = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        });
        return formatter.format(value);
      } else {
        return "";
      }
    },
    getSizesForFilter() {
      Size.getAll().then((response) => {
        this.sizes = response.data["data"];
      });
    },
    getDefaultSizesForFilter() {
      Voyage.getVoyageByCargoRid(this.rid).then((response) => {
        let sizes = response.data["data"]["sizes"];
        sizes.forEach((element) => {
          if(!this.filterSizes.includes(element.id))
            this.filterSizes.push(element.id);
        });
        this.filterApply();
      });
    },
    individualsName(owner) {
      let res = [];
      
      // Ensure owner and owner_size_zones exist
      if (!owner || !owner["owner_size_zones"]) {
        return res;
      }
      
      for (const key in owner["owner_size_zones"]) {
        if (key in owner["owner_size_zones"] && owner["owner_size_zones"][key]["zone"]["id"] == this.zoneId) {
          const individuals = owner["owner_size_zones"][key]["individuals"];
          if(this.filterRanks.length != 0 && this.filterRanks.indexOf(owner["owner_size_zones"][key]["rank"]) === -1) continue;
          if(owner["owner_size_zones"][key]["zone_id"] != this.zoneId) continue;
          if(this.filterSizes.length != 0 && this.filterSizes.indexOf(owner["owner_size_zones"][key]["owner_size"]["size_id"]) === -1) continue;

          // Ensure individuals is an array
          if (!Array.isArray(individuals)) {
            continue;
          }

          for (const kInd in individuals) {
            if (kInd in individuals) {
              const individual = individuals[kInd];
              
              if(individual["first_name"] || individual["surname"]) {
                res.push(individual["first_name"] + " " + individual["surname"]);
              } else {
                res.push("-");
              }
            }
          }

          
        }
      }
      return res;
    },
    individualsEmails(owner) {
      let res = [];
      let groupEmils = [];
      
      // Ensure owner and owner_size_zones exist
      if (!owner || !owner["owner_size_zones"]) {
        return res;
      }
      
      for (const key in owner["owner_size_zones"]) {
        if (key in owner["owner_size_zones"] && owner["owner_size_zones"][key]["zone"]["id"] == this.zoneId) {
          const individuals = owner["owner_size_zones"][key]["individuals"];

          if(this.filterRanks.length != 0 && this.filterRanks.indexOf(owner["owner_size_zones"][key]["rank"]) === -1) continue;
          if(owner["owner_size_zones"][key]["zone_id"] != this.zoneId) continue;
          if(this.filterSizes.length != 0 && this.filterSizes.indexOf(owner["owner_size_zones"][key]["owner_size"]["size_id"]) === -1) continue;

          // Ensure individuals is an array
          if (!Array.isArray(individuals)) {
            continue;
          }

          for (const kInd in individuals) {
            if (kInd in individuals) {
              const individual = individuals[kInd];
              let emails = [];

              if(individual["email"]) {
                emails.push(individual["email"]);
              }

              if(individual["group_email"]) {
                if(groupEmils.indexOf(individual["group_email"]) === -1) {
                  emails.push(individual["group_email"]);
                  groupEmils.push(individual["group_email"]);
                }
                
              }

              if(emails.length == 0) {
                res.push("-");
              } else {
                res.push(emails
                  .map(item => item.replace(";", ""))
                  .join("; ")
                  );
              }
            }
          }
          
        }
      }
      
      // Debug log to see what emails are being returned
      if (res.length > 0) {
        console.log(`Emails for ${owner.name}:`, res);
      }
      
      return res;
    },
    filterApply() {
      if (this.filterSizes == undefined) this.filterSizes = [];
      if (this.filterRanks == undefined) this.filterRanks = [];
      if (this.filterSizes.length == 0 && this.filterRanks.length == 0) {
        this.prepOwners = this.owners;
        return;
      }

      let tmpPrepOwwners = [];
      for(let ownerKey in this.owners) {
        const owner = this.owners[ownerKey];
        for (const key in owner["owner_size_zones"]) {
          if (owner["owner_size_zones"][key]["zone"]["id"] == this.zoneId) {
            // const individuals = owner["owner_size_zones"][key]["individuals"];
            // if(this.filterRanks.length != 0 && this.filterRanks.indexOf(owner["owner_size_zones"][key]["rank"]) === -1) continue;
            if(owner["owner_size_zones"][key]["zone_id"] != this.zoneId) continue;
            if(this.filterSizes.length != 0 && this.filterSizes.indexOf(owner["owner_size_zones"][key]["owner_size"]["size_id"]) === -1) continue;

            tmpPrepOwwners.push(owner);
            break;
            
          }
        }
      }
      this.prepOwners = tmpPrepOwwners;
    },

    saveEmailTemplate(updatedText, subject) {
      // updatedText — це текст з textarea
      console.log('Saved Template:', updatedText);
      this.cargo.email_template = updatedText;
      this.cargo.email_subject_template = subject;
      // this.emailContent = updatedText;
      Cargo.updateEmailTemplate(this.cargo.id, updatedText, subject)
        .then(response => {
          console.log('Email template updated successfully:', response);
          this.showModalEmailTemplatePopUp = false;
        })
        .catch(error => {
          console.error('Error updating email template:', error);
        });
    },

    // Contact editing methods
    openContactEditModal(owner) {
      this.currentOwnerForContactEdit = owner;
      this.contactData = {
        contact: this.getCurrentContact(owner) || {},
        contactedEmail: this.getCurrentContactEmail(owner) || ""
      };
      this.showContactEditModal = true;
    },

    handleContactModalStatus(status) {
      this.showContactEditModal = status;
      if (!status) {
        this.currentOwnerForContactEdit = null;
      }
    },

    handleContactUpdated(contactData) {
      console.log("Contact updated:", contactData);
      
      // Immediately update local data for instant display
      if (this.currentOwnerForContactEdit) {
        this.updateOwnerContactImmediately(this.currentOwnerForContactEdit, contactData);
      }
      
      // Then reload from server in background to ensure sync
      Cargo.getOwnersByCargoRid(this.rid).then((response) => {
        this.owners = response.data["data"];
        this.prepOwners = response.data["data"];
        this.filterApply();
      }).catch((error) => {
        console.error("Error reloading owners data:", error);
      });
    },

    getCurrentContact(owner) {
      // Get the first contact from individualsName
      const names = this.individualsName(owner);
      if (names && names.length > 0) {
        return { name: names[0] };
      }
      return null;
    },

    getCurrentContactEmail(owner) {
      // Get the first email from individualsEmails
      const emails = this.individualsEmails(owner);
      if (emails && emails.length > 0) {
        return emails[0];
      }
      return "";
    },

    updateOwnerContactImmediately(owner, contactData) {
      console.log("Updating contact immediately for owner:", owner.name, contactData);
      
      // Find the owner in the owners array
      const ownerIndex = this.owners.findIndex(o => o.id === owner.id);
      
      if (ownerIndex === -1) return;
      
      const targetOwner = this.owners[ownerIndex];
      
      if (!contactData.contacts || contactData.contacts.length === 0) {
        // If no contacts, clear them
        if (targetOwner.contacts) {
          targetOwner.contacts = [];
        }
        // Update prepOwners
        const prepOwnerIndex = this.prepOwners.findIndex(o => o.id === owner.id);
        if (prepOwnerIndex !== -1) {
          this.prepOwners[prepOwnerIndex] = { ...targetOwner };
        }
        this.$forceUpdate();
        return;
      }
      
      // Determine if this is individuals or contacts based on data structure
      const isIndividuals = contactData.contacts.some(c => c.contact_name !== undefined);
      const isContacts = contactData.contacts.some(c => c.name !== undefined);
      
      if (isIndividuals) {
        // Update individuals in owner_size_zones
        for (const key in targetOwner.owner_size_zones) {
          const zoneData = targetOwner.owner_size_zones[key];
          
          if (zoneData.zone.id === this.zoneId) {
            const individuals = zoneData.individuals || [];
            
            // Check if this zone matches our filters
            const isFilteredByRank = this.filterRanks.length > 0 && !this.filterRanks.includes(zoneData.rank);
            const isFilteredBySize = this.filterSizes.length > 0 && !this.filterSizes.includes(zoneData.owner_size.size_id);
            const isFilteredByZone = this.zoneId && zoneData.zone_id !== this.zoneId;
            
            if (isFilteredByRank || isFilteredBySize || isFilteredByZone) {
              continue; // Skip filtered zones
            }
            
            // Update individuals with new contact data
            contactData.contacts.forEach(updatedContact => {
              if (updatedContact.contact_name !== undefined && updatedContact.email !== undefined) {
                // Find existing individual by ID
                const existingIndex = individuals.findIndex(ind => ind.id === updatedContact.id);
                
                if (existingIndex !== -1) {
                  // Update existing individual
                  const nameParts = updatedContact.contact_name.split(' ').filter(p => p);
                  individuals[existingIndex] = {
                    ...individuals[existingIndex], // Preserve existing data like group_email
                    first_name: nameParts[0] || '',
                    surname: nameParts.slice(1).join(' ') || '',
                    email: updatedContact.email.trim() || '',
                    group_email: individuals[existingIndex].group_email || ''
                  };
                } else if (updatedContact.id) {
                  // Add new individual if not found and has ID
                  const nameParts = updatedContact.contact_name.split(' ').filter(p => p);
                  const newIndividual = {
                    id: updatedContact.id,
                    first_name: nameParts[0] || '',
                    surname: nameParts.slice(1).join(' ') || '',
                    email: updatedContact.email.trim() || '',
                    group_email: '',
                    disable: 0
                  };
                  individuals.push(newIndividual);
                }
              }
            });
          }
        }
      } else if (isContacts) {
        // Update contacts array
        if (!targetOwner.contacts) {
          targetOwner.contacts = [];
        }
        
        // Clear existing contacts and add updated ones
        targetOwner.contacts = contactData.contacts
          .filter(c => c.name && c.name.trim())
          .map(contact => {
            const nameParts = (contact.name || '').trim().split(' ').filter(p => p);
            return {
              id: contact.id || null,
              first_name: nameParts[0] || '',
              surname: nameParts.slice(1).join(' ') || '',
              email: (contact.email || '').trim() || ''
            };
          });
      }
      
      // Update the prepOwners array to reflect changes immediately
      const prepOwnerIndex = this.prepOwners.findIndex(o => o.id === owner.id);
      if (prepOwnerIndex !== -1) {
        this.prepOwners[prepOwnerIndex] = { ...targetOwner };
      }
      
      // Force reactivity update
      this.$forceUpdate();
    },

    updateOwnerContact(owner, contactData) {
      console.log("Updating contact for owner:", owner.name, contactData);
      
      // Find the owner in the owners array and update their individuals data
      const ownerIndex = this.owners.findIndex(o => o.id === owner.id);
      
      if (ownerIndex !== -1) {
        const targetOwner = this.owners[ownerIndex];
        
        // Update individuals in owner_size_zones
        for (const key in targetOwner.owner_size_zones) {
          const zoneData = targetOwner.owner_size_zones[key];
          
          if (zoneData.zone.id === this.zoneId) {
            const individuals = zoneData.individuals;
            
            // Check if this zone matches our filters
            const isFilteredByRank = this.filterRanks.length > 0 && !this.filterRanks.includes(zoneData.rank);
            const isFilteredBySize = this.filterSizes.length > 0 && !this.filterSizes.includes(zoneData.owner_size.size_id);
            const isFilteredByZone = this.zoneId && zoneData.zone_id !== this.zoneId;
            
            if (isFilteredByRank || isFilteredBySize || isFilteredByZone) {
              continue; // Skip filtered zones
            }
            
            // Update individuals with new contact data
            if (contactData.contacts && contactData.contacts.length > 0) {
              // Update only the individuals that were changed, preserve others
              contactData.contacts.forEach(updatedContact => {
                if (updatedContact.contact_name && updatedContact.email !== undefined) {
                  // Find existing individual by ID
                  const existingIndex = individuals.findIndex(ind => ind.id === updatedContact.id);
                  
                  if (existingIndex !== -1) {
                    // Update existing individual
                    const nameParts = updatedContact.contact_name.split(' ');
                    individuals[existingIndex] = {
                      ...individuals[existingIndex], // Preserve existing data like group_email
                      first_name: nameParts[0] || '',
                      surname: nameParts.slice(1).join(' ') || '',
                      email: updatedContact.email || '',
                      // Keep existing group_email if it exists
                      group_email: individuals[existingIndex].group_email || ''
                    };
                  } else {
                    // Add new individual if not found
                    const nameParts = updatedContact.contact_name.split(' ');
                    const newIndividual = {
                      id: updatedContact.id,
                      first_name: nameParts[0] || '',
                      surname: nameParts.slice(1).join(' ') || '',
                      email: updatedContact.email || '',
                      group_email: '', // New individuals start with empty group_email
                      disable: 0
                    };
                    individuals.push(newIndividual);
                  }
                }
              });
            }
          }
        }
        
        // Also update the prepOwners array to reflect changes immediately
        const prepOwnerIndex = this.prepOwners.findIndex(o => o.id === owner.id);
        if (prepOwnerIndex !== -1) {
          this.prepOwners[prepOwnerIndex] = { ...targetOwner };
        }
      }
    },

  },
};
</script>
  
<style scoped>
/*.multiselect-container {*/
/*  min-height: 300px; !* Встановіть потрібну висоту *!*/
/*  overflow-y: auto;  !* Додайте вертикальну прокрутку *!*/
/*}*/

.multiselect-container {
  max-height: none !important;
}

a {
  color: #42b983;
}

td {
  border-right: 1px solid #d3dfed;
  border-bottom: 1px solid #d3dfed;
  /* padding: 15px; */
}
.report-body {
  position: relative;
  margin-top: 10px;
  padding-bottom: 10px;
  width: max-content;
  display: flex;
}
.report-body-wrap {
  width: max-content;
}

thead {
  background: #f6faff;
}

tbody {
  border-top: 1px solid #d3dfed;
  border-left: 1px solid #d3dfed;
}

.report-table {
  table-layout: fixed;
  border-collapse: collapse;
  position: relative;
}

.report-table thead tr {
  position: relative;
}

.report-table .checkbox-cell {
  padding: 0 5px;
}

.report-table .checkbox-cell div {
  height: 14px;
  margin: 4px;
}

th {
  position: sticky;
  z-index: 1;
  border: 0;
  padding: 15px 10px;
  color: rgb(255, 255, 255);
  -webkit-font-smoothing: antialiased;
  cursor: default;
  vertical-align: middle;

  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #2d3757;
}

.report-table td div {
  white-space: nowrap;
}

.report-table__head {
  position: sticky;
  z-index: 1;
}

td {
  padding: 5px;
}

.send-done-wrap:hover .send-icon {
  transform: scale(1.2);
}

.imgs-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.send-icon,
.check-done-icon {
  width: 25px;
  height: 25px;
  display: block;
}

.send-icon {
  cursor: pointer;
  transition: transform .2s linear;
}

.q-currency-input {
  width: 100px;
}

</style>

<style scoped>
textarea {
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #2c3e50;
  padding: 2px;
  width: 100%;
  min-width: 160px;
  box-sizing: border-box;
}

.btn-log {
  position: relative;
}

.btn-log__body {
  display: none;
  width: max-content;
  position: absolute;
  background: #2d3757;
  color: #fff;
  z-index: 5;
  padding: 5px;
  left: 0;
  bottom: 20px;
  border-radius: 2px;
  box-shadow: -1px -1px 10px 0px #2d375780;
  border: 1px solid #d3dfed;
  max-height: 300px;
  overflow-y: auto;
  flex-direction: column-reverse;
}

.btn-log:hover .btn-log__body {
  display: flex;
}

.field-title__btn-log {
  cursor: pointer;
  margin: 5px;
  border-radius: 50px;
  background:  #2d3757;
  color: #fff;
  padding: 2px 7px;
  z-index: 100;
}

.field__empty {
  min-height: 43px; 
  display: flex; 
  align-items: center;
}

.template-button {
  border: 1px solid #2d3757;
  border-radius: 2px;
  /* padding: 10px; */
  background-color: #2d3757;
  color: white;
  /* margin-right: 15px; */
  cursor: pointer;
  /* display: inline-block; */
  display: flex;
  align-items: center;
  /* min-width: 95px; */
  /* margin-left: 5px; */
  position: absolute;
  top: -50px;
  /* left: calc(50% - 37px); */
  left: 0;
  right: 0;
  height: 35px;
  width: 90%;
}
.reply-all-button {
  border: 1px solid #2d3757;
  border-radius: 2px;
  padding: 10px;
  /* box-sizing: border-box; */
  /* margin-right: 15px; */
  cursor: pointer;
  /* display: inline-block; */
  align-items: center;
  min-width: 55px;
  background-color: #2d3757;
  color: white;
  position: absolute;
  top: -50px;
  /* left: calc(50% - 37px); */
  left: 0;
  right: 0;
  /* width: 57px; */
}

.reply-all-button:hover {
  background-color: #f6faff;
  color: #2d3757;
}

.template-button:hover {
  background-color: #f6faff;
  color: #2d3757;
}

.edit-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/Edit_fill.svg) no-repeat center center;
}

.edit-button__img:hover {
  cursor: pointer;
}

.preview-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/btn-preview.svg) no-repeat center center;
}

.preview-button__img:hover {
  cursor: pointer;
}

.send-button__img {
  width: 16px;
  height: 16px;
  background: url(@/assets/send-icon.svg) no-repeat center center;
  background-size: cover;
  /* background-size: 16px 16px; */
}

.send-button__img:hover {
  cursor: pointer;
}

.top-panel {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  margin-bottom: 10px;
}

@media screen and (max-width: 768px) {
  .top-panel {
    display: block;
  }
  
}

/* Contact editing styles */
.contact-cell-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
}

.contact-names {
  flex: 1;
  min-width: 0;
}

.contact-edit-button {
  background: #2d3757;
  border: none;
  border-radius: 2px;
  padding: 6px 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.contact-edit-button:hover {
  background: #1e2a3f;
}

.edit-icon {
  width: 14px;
  height: 14px;
  background-color: white;
  mask: url(@/assets/icon-pencil.svg) no-repeat center center;
  mask-size: contain;
  -webkit-mask: url(@/assets/icon-pencil.svg) no-repeat center center;
  -webkit-mask-size: contain;
}
</style>